import addIssue from 'serviceWorker/services/httpQueue/issue/addIssue';
import editIssue from 'serviceWorker/services/httpQueue/issue/editIssue';
import type { ContractShapeOf, RequestHandlers } from 'shared/channels';
import type { issueContract } from 'shared/domain/issue/issueContract';
import { issueDeleter, issueRestorer } from './changeIssueArchival';

/**
 * Issue changes put on the HTTP queue; each resolves once queued and its
 * outcome follows as an event with the change's `uniqueId`. Checked against
 * the issue contract.
 */
export const queueIssueChanges = {
  create: ({ issue, uniqueId }) => addIssue(issue, uniqueId),
  edit: ({ address, model, uniqueId }) => editIssue(address, model, uniqueId),
  /** Archives the issue locally at once; the server's answer follows. */
  remove: ({ issueId, uniqueId }) => issueDeleter.execute(issueId, uniqueId),
  /** Restores the issue locally at once; the server's answer follows. */
  restore: ({ issueId, uniqueId }) => issueRestorer.execute(issueId, uniqueId),
} satisfies RequestHandlers<ContractShapeOf<typeof issueContract>>;
